import React, { useEffect, useState } from 'react';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import { loginRequest } from '../authConfig';
import { useAuth } from '../hooks/useAuth';
import './Login.css';

const features = [
  {
    icon: '☁️',
    title: 'Secure Cloud Storage',
    description: 'Your files stored safely with Azure enterprise-grade security',
  },
  {
    icon: '⚡',
    title: 'Beautiful, Modern Interface',
    description: 'A sleek experience built for speed and simplicity',
  },
  {
    icon: '🔗',
    title: 'Instant File Sharing',
    description: 'Share files with a single click using secure temporary links',
  },
];

export default function Login() {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const [activeFeature, setActiveFeature] = useState(0);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/home');
    }
  }, [isAuthenticated, navigate]);

  // Auto-rotate features every 3 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveFeature((prev) => (prev + 1) % features.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const handleLogin = async () => {
    try {
      await instance.loginRedirect(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
    }
  };

  return (
    <div className="login-container">
      {/* Left panel - Feature highlights */}
      <div className="login-feature-panel">
        <div className="login-brand">
          <span className="login-brand-icon">📦</span>
          <span className="login-brand-name">Trubonn</span>
        </div>

        <div className="login-feature-content">
          <div className="login-feature-icon">{features[activeFeature].icon}</div>
          <h2 className="login-feature-title">{features[activeFeature].title}</h2>
          <p className="login-feature-description">{features[activeFeature].description}</p>

          {/* Dot indicators */}
          <div className="login-feature-dots">
            {features.map((_, i) => (
              <button
                key={i}
                className={`login-feature-dot ${i === activeFeature ? 'active' : ''}`}
                onClick={() => setActiveFeature(i)}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Right panel - Sign in card */}
      <div className="login-card">
        <div className="login-header">
          <h1>Welcome back</h1>
          <p>Sign in to access your files</p>
        </div>

        <div className="login-content">
          <button
            className="login-button"
            onClick={handleLogin}
          >
            Sign In / Sign Up
          </button>
        </div>

        <div className="login-footer">
          <p>Secure • Private • Reliable</p>
        </div>
      </div>
    </div>
  );
}
